import React, { FC, useState } from 'react'
import { MinNavContainer, MinNavMenu } from './style'

//* utils
import { MenuGroup } from '../../../models/others/menuGroup'
import { MenuNav } from '../../../models/others/menuNav'

//* Components
import { MinNavLinks } from './subcomponents/minNavLinks'
import {
  MinNavButton,
  MinNavHamburgerIcon,
  MinNavLogo,
  MinNavTopHatLinks,
} from './subcomponents/minNavParts'

type Props = {
  headerData: MenuNav
  uiPathSrc: string
}

const MinHeader: FC<Props> = ({ headerData, uiPathSrc }) => {
  if (!headerData) return null
  const [menuOpen, setMenuOpen] = useState(false)

  const menuGroups = (headerData.menuGroups as MenuGroup[]) || []
  const primaryCta = headerData.primaryCta || {}
  const topHatLinks = headerData.topHatLinks || []
  const locale = headerData.node_locale
  const location = headerData?.location

  const handleMenuOpen = () => {
    setMenuOpen(!menuOpen)
    document.body.classList.toggle('scroll-lock')
  }

  const sidebar = (
    <section className="MinNav__Sidebar" id="minHeader">
      <MinNavMenu id="MinNav__Menu" $menuOpen={menuOpen}>
        <header className="MinNav__Header">
          <MinNavHamburgerIcon handleMenuOpen={handleMenuOpen} menuOpen={menuOpen} />
          <MinNavLogo uiPathSrc={uiPathSrc} locale={locale} />
        </header>

        <MinNavTopHatLinks topHatLinks={topHatLinks} />
        <MinNavLinks menuGroups={menuGroups} uiPathSrc={uiPathSrc} location={location} />

        {primaryCta && <MinNavButton primaryCta={primaryCta} />}
      </MinNavMenu>
    </section>
  )

  return (
    <MinNavContainer data-cy="minHeader" $menuOpen={menuOpen}>
      {menuOpen ? (
        <>
          <div className="MinNav__Overlay" onClick={handleMenuOpen}></div>
          {sidebar}
        </>
      ) : (
        <header className="MinNav__Sidebar" id="minHeader">
          <MinNavLogo uiPathSrc={uiPathSrc} locale={locale} />
          <MinNavHamburgerIcon handleMenuOpen={handleMenuOpen} menuOpen={menuOpen} />
        </header>
      )}
    </MinNavContainer>
  )
}

export default MinHeader
